import utility from 'src/utils/utility'
import { useContext, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import AppInfoContext from 'src/provider/state-manager/appInfoProvider'
import ApiContext from 'src/provider/API/call-service'
import { 
    AppSpan, Button, Circle, CustomContainer, FlexColumn, FlexRow, Form, 
    FormGroup, GridContainer, ScreenContainer, ScreenTitle 
} from 'src/style'
import ProfilePics from 'src/assets/svg/profile-pics.svg'
import { UserType } from 'src/model'

const SignIn: React.FC = () => {
    const navigate = useNavigate()
    const {API} = useContext(ApiContext)
    const {setInfoProperty} = useContext(AppInfoContext)
    const [input, setInput] = useState({email: '', password: ''})

    async function handleLogin(e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
        e.preventDefault()
        const loggedInUser = await API.login(input)

        if (loggedInUser) {
            let userType = loggedInUser.userType

            if (userType != UserType.ADMIN) {
                const response = await API.getLoggedInUser()
                
                if (response) {
                    userType = response.hasSubsidiaries ? UserType.COMPANY : UserType.INDIVIDUAL
                }
                else return false
            }

            await setInfoProperty('userType', userType)
            navigate('/dashboard/home')
        }
    }
    
    return (
        <ScreenContainer padding='2.5' >
            <GridContainer 
                height='100' hUnit='%'
            >
                <CustomContainer className='preauth-screen-wrapper'>
                    <CustomContainer>
                        <ScreenTitle 
                            color='#000000'
                            textSize='3.2'
                            fontWeight='700'
                        >
                            Sign in to your account
                        </ScreenTitle>
                        <AppSpan
                            textSize='1.6'
                            color='#4F4F4F'
                        >
                            Lorem ac, arcu, at sed vestibulum, malesuada. Amet, orci ultrices pellentesque aliquam nec. 
                        </AppSpan>
                    </CustomContainer>
                    <Form topMargin='4' onSubmit={handleLogin}>
                        <FormGroup>
                            <label>Email</label>
                            <input 
                                placeholder='Enter Email' 
                                name='email'
                                type='email'
                                value={input.email}
                                autoComplete="off"
                                required
                                onChange={(e) => setInput({...input, email: e.target.value})}
                            />
                        </FormGroup>
                        <FormGroup>
                            <label>Password</label>
                            <input 
                                placeholder='Enter Password' 
                                name='password'
                                type='password'
                                value={input.password}
                                autoComplete="off"
                                required
                                onChange={(e) => setInput({...input, password: e.target.value})}
                            />
                        </FormGroup>
                        <AppSpan
                            textSize='1.6'
                            color='#5627FF'
                            hoverColor='#4F4F4F'
                            fontWeight='700'
                            cursor='pointer'
                            onClick={() => navigate('/forgot-password/identification')}
                        >
                            Forgot Password?
                        </AppSpan>
                        
                        <Button 
                            width='100' 
                            sizeUnit='%'
                            hoverBgColor='#ffffff' 
                            hoverColor='#5627FF'
                            borderColor='#5627FF'
                            topMargin='4'
                        >
                            Sign In
                        </Button>
                    </Form>

                    <CustomContainer topMargin='6'>
                        <AppSpan
                            color='#333333'
                            textSize='1.6'
                            fontWeight='700'
                        >
                            Recent Login
                        </AppSpan>
                        <CustomContainer
                            topMargin='2'
                            className='scrollable-container'
                        >
                            <FlexRow
                                alignItems='flex-start'
                                gap='1'
                            >
                                {
                                    Array.from(Array(5).keys()).map((item, index) => {
                                        return (
                                            <FlexColumn 
                                                borderColor='#E4DCFF'
                                                width='10.4'
                                                minHeight='11.6'
                                                radius='0.8'
                                                bgColor='#ffffff'
                                                justifyContent='flex-start'
                                                padding='1'
                                                key={index}
                                                className='scroll-x-text'
                                            >
                                                <Circle
                                                    size='4.8' 
                                                    overflow='hidden'
                                                    bottomMargin='0.5'
                                                >
                                                    <img src={ProfilePics} className='img-child'/>
                                                </Circle>
                                                <AppSpan
                                                    textSize='1.2'
                                                    color='#4F4F4F'
                                                    align='center'
                                                >
                                                    Ridwan Kolawole
                                                </AppSpan>
                                            </FlexColumn>
                                        )
                                    })
                                }
                            </FlexRow>
                        </CustomContainer>
                    </CustomContainer>
                </CustomContainer>
            </GridContainer>
        </ScreenContainer>
    )
}

export default utility.routeData('/login', 'SignIn', <SignIn/>)